export default class extends Controller {
  static targets = ['linkForm'];

  connect() {
    this.openLinkForm = this.openLinkForm.bind(this)
  }

  editLink(event) {
    const { name, url, id, elId } = event.target.dataset;
    event.target.classList.add('link-in-edit-mode');
    this.openLinkForm(event, { name, url, id, elId });
  }

  openLinkForm(event, { name = '', url = '', id = '', elId = '' } = {}) {
    event.preventDefault();
    const template = document.createElement('div');
    const scriptTag = this.linkFormTarget.querySelector("script")
    const templateHTML = scriptTag.innerHTML
    template.innerHTML = templateHTML
                          .replace('$LINK_NAME', name)
                          .replace('$LINK_URL', url)
                          .replace('$LINK_ID', id)
                          .replace('$LINK_EL_ID', elId);
    App.SlideOut.open({
      contentHTML: template.innerHTML,
      element: this.element,
      headerColor: "blue-color",
      title: "Add Link Attachment",
      beforeClose: () => {
        event.target.classList.remove('link-in-edit-mode');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/messages/messages-forms-links-attributes-controller.js